import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaHandHoldingHeart, FaChartLine, FaFileInvoiceDollar, FaGraduationCap, FaUserShield, FaShieldAlt, FaHandshake, FaLightbulb, FaBalanceScale, FaRegChartBar } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const slideInLeft = keyframes`
  from { opacity: 0; transform: translateX(-100px); }
  to { opacity: 1; transform: translateX(0); }
`;

const slideInRight = keyframes`
  from { opacity: 0; transform: translateX(100px); }
  to { opacity: 1; transform: translateX(0); }
`;

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(50px); }
  to { opacity: 1; transform: translateY(0); }
`;

const FAQContainer = styled.div`
  display: flex;
  gap: 40px;
  width: 100%;
  background: white;
  padding: 40px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 20px;
  }
`;

const FAQContent = styled.div`
  flex: 1;
  animation: ${slideInRight} 1s ease-in-out;
`;

const FAQItem = styled.div`
  background: #ffffff;
  margin: 15px 0;
  border-bottom: 1px solid #d1d5db;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
  opacity: 0;
  transform: translateY(20px);
  animation: ${fadeUp} 0.5s ease-in-out forwards;
  animation-delay: ${({ delay }) => delay || "0s"};

  &:hover {
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

const Question = styled.div`
  background: #f9fafb;
  padding: 15px;
  font-size: 18px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background 0.3s ease;

  &:hover {
    background: #eef1f6;
  }
`;

const Answer = styled.div`
  padding: 15px;
  font-size: 16px;
  color: #555;
  background: #ffffff;
  border-top: 1px solid #d1d5db;
  animation: ${fadeIn} 0.5s ease-in-out;
`;

const Icon = styled.span`
  font-size: 22px;
  font-weight: bold;
  color: #4682B4;
  transition: transform 0.3s ease;
  ${({ isOpen }) => isOpen && "transform: rotate(180deg);"}
`;

const ServiceCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  margin-bottom: 30px;
  animation: ${fadeUp} 0.5s ease-in-out forwards;
  animation-delay: ${({ delay }) => delay || "0s"};
  height: 100%;
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  }
`;

const ServiceIcon = styled.div`
  font-size: 42px;
  color: ${props => props.color || "#4682B4"};
  margin-bottom: 20px;
`;

const ServiceTitle = styled.h4`
  font-weight: 700;
  margin-bottom: 15px;
  color: #333;
`;

const ServiceDescription = styled.p`
  color: #666;
  font-size: 16px;
  line-height: 1.6;
`;

const AdvantageCard = styled.div`
  padding: 25px 15px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  }
`;

const AdvantageIcon = styled.div`
  font-size: 48px;
  margin-bottom: 15px;
  color: ${props => props.color || "#0d6efd"};
`;

const Section = styled.section`
  padding: 80px 0;
  background: ${props => props.background || "white"};
`;

const ServiceList = styled.ul`
  list-style-type: none;
  padding-left: 0;
`;

const ServiceItem = styled.li`
  margin-bottom: 10px;
  position: relative;
  padding-left: 25px;
  
  &:before {
    content: "•";
    color: #4682B4;
    font-weight: bold;
    font-size: 20px;
    position: absolute;
    left: 0;
    top: -2px;
  }
`;

const AssociationsONG = () => {
    const [activeIndex, setActiveIndex] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const faqSection = document.getElementById("faq-section");
            if (faqSection) {
                const rect = faqSection.getBoundingClientRect();
                if (rect.top < window.innerHeight * 0.8 && rect.bottom > 0) {
                    setIsVisible(true);
                } else {
                    setIsVisible(false);
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    

  

    

   

    return (
        <>
            <Header />

            <section className="service-banner d-flex align-items-center">
                <div className="container-fluid px-4 px-md-5 text-white">
                    <div className="row">
                        <div className="col-lg-8">
                            <h1 className="fw-bold display-4 mb-3">Associations, ONG et Fondations</h1>
                            <p className="fs-5 mb-4">Nous soutenons votre engagement avec une expertise comptable dédiée</p>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/" className="text-white text-decoration-none">
                                            Accueil
                                        </Link>{" "}
                                        /{" "}
                                        <Link to="/services" className="text-white text-decoration-none">
                                            Services
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active text-white" aria-current="page">
                                        Associations, ONG et Fondations
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>

            <Section>
                <div className="container-fluid px-4 px-md-5">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="fw-bold custom-title text-center mb-5">
                                Une expertise comptable et financière dédiée aux entités à but non lucratif
                            </h2>
                            <p className="text-muted text-center fs-5 mb-5">
                                Vous œuvrez au sein d'une association, d'une ONG, d'une fondation, ou d'une autre structure à but non lucratif ? 
                                Votre mission est de créer de la valeur sociale, environnementale ou sociétale. CINEF-EC partage vos valeurs et vous 
                                apporte une expertise comptable, financière et juridique adaptée aux spécificités de votre secteur, pour vous permettre 
                                de vous concentrer sur votre cœur de métier.
                            </p>
                        </div>
                    </div>

                    <div className="row mb-5">
                        <div className="col-12">
                            <div className="bg-light p-5 rounded-3">
                                <h3 className="fw-bold custom-title mb-4">
                                    Pourquoi choisir CINEF-EC pour votre entité à but non lucratif ?
                                </h3>
                                <div className="row">
                                    <div className="col-md-6 mb-4">
                                        <div className="d-flex">
                                            <div className="me-3">
                                                <FaUserShield className="fs-1 text-primary" />
                                            </div>
                                            <div>
                                                <h5 className="fw-bold">Expertise spécialisée</h5>
                                                <p className="text-muted">
                                                    Nous maîtrisons les spécificités comptables, fiscales et juridiques 
                                                    propres aux associations, ONG et fondations.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-4">
                                        <div className="d-flex">
                                            <div className="me-3">
                                                <FaRegChartBar className="fs-1 text-info" />
                                            </div>
                                            <div>
                                                <h5 className="fw-bold">Approche sur mesure</h5>
                                                <p className="text-muted">
                                                    Nos solutions s'adaptent à la taille et aux besoins spécifiques de 
                                                    votre structure et de vos projets.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-4">
                                        <div className="d-flex">
                                            <div className="me-3">
                                                <FaHandHoldingHeart className="fs-1 text-danger" />
                                            </div>
                                            <div>
                                                <h5 className="fw-bold">Partage de valeurs</h5>
                                                <p className="text-muted">
                                                    Nous comprenons et soutenons votre mission sociale, environnementale ou sociétale 
                                                    avec une approche éthique et engagée.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 mb-4">
                                        <div className="d-flex">
                                            <div className="me-3">
                                                <FaHandshake className="fs-1 text-warning" />
                                            </div>
                                            <div>
                                                <h5 className="fw-bold">Accompagnement global</h5>
                                                <p className="text-muted">
                                                    De la comptabilité au conseil stratégique, en passant par l'audit et la formation, 
                                                    nous vous offrons un service complet.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Section>

            <Section>
                <div className="container-fluid px-4 px-md-5">
                    <div className="row mb-5">
                        <div className="col-12">
                            <h3 className="fw-bold custom-title mb-4">Détail de nos prestations</h3>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 mb-4">
                            <div className="h-100 p-4 border rounded-3 bg-white shadow-sm">
                                <h4 className="fw-bold mb-3 text-primary">1. Comptabilité, Fiscalité et Gestion Sociale</h4>
                                <ServiceList>
                                    <ServiceItem>Tenue et révision comptable adaptée aux spécificités du secteur</ServiceItem>
                                    <ServiceItem>Établissement des comptes annuels et rapports financiers</ServiceItem>
                                    <ServiceItem>Gestion de la fiscalité spécifique aux entités non lucratives</ServiceItem>
                                    <ServiceItem>Déclarations fiscales et sociales</ServiceItem>
                                    <ServiceItem>Gestion de la paie et des spécificités (bénévolat, volontariat)</ServiceItem>
                                    <ServiceItem>Assistance en cas de contrôle fiscal ou social</ServiceItem>
                                    <ServiceItem>Comptabilité analytique par projet et source de financement</ServiceItem>
                                </ServiceList>
                            </div>
                        </div>
                        
                        <div className="col-md-6 mb-4">
                            <div className="h-100 p-4 border rounded-3 bg-white shadow-sm">
                                <h4 className="fw-bold mb-3 text-purple">2. Audit et Contrôle</h4>
                                <ServiceList>
                                    <ServiceItem>Audit légal (commissariat aux comptes)</ServiceItem>
                                    <ServiceItem>Audit contractuel des procédures internes</ServiceItem>
                                    <ServiceItem>Mise en place et optimisation du contrôle interne</ServiceItem>
                                    <ServiceItem>Audit d'acquisition pour les opérations de croissance externe</ServiceItem>
                                    <ServiceItem>Audit spécifique des projets financés</ServiceItem>
                                    <ServiceItem>Évaluation des risques financiers et organisationnels</ServiceItem>
                                </ServiceList>
                            </div>
                        </div>
                        
                        <div className="col-md-6 mb-4">
                            <div className="h-100 p-4 border rounded-3 bg-white shadow-sm">
                                <h4 className="fw-bold mb-3 text-danger">3. Conseil et Accompagnement Stratégique</h4>
                                <ServiceList>
                                    <ServiceItem>Accompagnement à la création et au développement</ServiceItem>
                                    <ServiceItem>Conseil en gestion financière et recherche de financements</ServiceItem>
                                    <ServiceItem>Conseil en gestion des ressources humaines</ServiceItem>
                                    <ServiceItem>Accompagnement des projets et évaluation</ServiceItem>
                                    <ServiceItem>Conseil en matière de gouvernance associative</ServiceItem>
                                    <ServiceItem>Conseil juridique en partenariat avec des avocats spécialisés</ServiceItem>
                                    <ServiceItem>Accompagnement à la transformation digitale</ServiceItem>
                                    <ServiceItem>Conseil en matière de réglementation spécifique</ServiceItem>
                                </ServiceList>
                            </div>
                        </div>
                        
                        <div className="col-md-6 mb-4">
                            <div className="h-100 p-4 border rounded-3 bg-white shadow-sm">
                                <h4 className="fw-bold mb-3 text-success">4. Formations</h4>
                                <ServiceList>
                                    <ServiceItem>Formations sur-mesure pour vos équipes et bénévoles</ServiceItem>
                                    <ServiceItem>Formation en comptabilité associative</ServiceItem>
                                    <ServiceItem>Formation en gestion budgétaire et financière</ServiceItem>
                                    <ServiceItem>Formation sur la réglementation du secteur non lucratif</ServiceItem>
                                    <ServiceItem>Formation sur la recherche de financements</ServiceItem>
                                    <ServiceItem>Formations inter- ou intra-structures</ServiceItem>
                                </ServiceList>
                            </div>
                        </div>
                    </div>
                </div>
            </Section>

           
           

            <Footer />

            <style>{`
        .service-banner {
          background: linear-gradient(to right, rgba(0, 138, 68, 0.85), rgba(220, 53, 69, 0.85)), 
                      url("/assets/images/image-associations.jpg") no-repeat center center;
          background-size: cover;
          background-position: center;
          height: 400px;
          display: flex;
          align-items: center;
        }

        .breadcrumb {
          background: transparent;
          font-size: 18px;
        }

        .breadcrumb-item a {
          color: white;
          font-weight: 500;
        }

        .custom-title {
          position: relative;
          padding-bottom: 15px;
        }

        .custom-title:after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          width: 60px;
          height: 3px;
          background: linear-gradient(to right, #008a44, #dc3545);
        }

        .text-center .custom-title:after {
          left: 50%;
          transform: translateX(-50%);
        }

        .custom-underline {
          height: 4px;
          width: 70px;
          background: linear-gradient(to right, #008a44, #dc3545);
          margin-top: 10px;
        }

        .call-to-action {
          background: linear-gradient(to right, #008a44, #dc3545);;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        }

        #faq-section {
          opacity: 0;
          transform: translateY(30px);
          transition: all 0.8s ease;
        }

        #faq-section.visible {
          opacity: 1;
          transform: translateY(0);
        }
        
        .text-purple {
          color: #6f42c1;
        }
        
        @media (max-width: 768px) {
          .service-banner {
            height: 350px;
          }
          
          .custom-title {
            font-size: 1.75rem;
          }
        }
      `}</style>
        </>
    );
};

export default AssociationsONG;